import React from 'react';
import { Smartphone, Layers, Code, ShoppingCart, Network, RefreshCw, ArrowRight } from 'lucide-react';
import { mobileAppSubServices } from '../../data/servicesData';

interface MobileAppServicesProps {
  onLearnMore: () => void;
}

export const MobileAppServices: React.FC<MobileAppServicesProps> = ({ onLearnMore }) => {
  const getSubIcon = (name: string) => {
    const cls = "w-5 h-5 text-[#159DE8]";
    switch (name) {
      case 'Smartphone': return <Smartphone className={cls} />;
      case 'Layers': return <Layers className={cls} />;
      case 'Code': return <Code className={cls} />;
      case 'ShoppingCart': return <ShoppingCart className={cls} />;
      case 'Network': return <Network className={cls} />;
      case 'RefreshCw':
      default:
        return <RefreshCw className={cls} />;
    }
  };

  return (
    <section className="bg-[#071426] py-16 border-b border-[#1b2f4a] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading */}
        <div className="text-center mb-12 space-y-2">
          <div className="inline-flex items-center gap-2">
            <span className="h-px w-8 bg-[#FF851B]" />
            <span className="text-xs font-bold uppercase tracking-widest text-[#FF851B]">
              SPECIALIZED CAPABILITIES
            </span>
            <span className="h-px w-8 bg-[#FF851B]" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white font-display">
            Mobile App Development Services
          </h2>
          <p className="text-xs sm:text-sm text-[#8FA0B8] max-w-xl mx-auto">
            High-performance iOS, Android, and cross-platform mobile solutions engineered for exceptional user retention.
          </p>
        </div>

        {/* 6 Sub-service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mobileAppSubServices.map((sub, idx) => (
            <div
              key={idx}
              className="p-5 rounded-xl bg-[#0c1a2d] border border-[#1b2f4a] hover:border-[#159DE8]/40 transition-all duration-200 group flex items-start gap-4"
            >
              <div className="p-2.5 rounded-lg bg-[#0B2342] border border-[#1b2f4a] shrink-0 group-hover:scale-110 transition-transform">
                {getSubIcon(sub.iconName)}
              </div>
              <div className="space-y-1">
                <h3 className="text-sm font-bold text-white group-hover:text-[#FF851B] transition-colors">
                  {sub.title}
                </h3>
                <p className="text-xs text-[#8FA0B8] leading-relaxed">
                  {sub.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
